import $ from 'jquery';
import {is_function} from '../../../Helpers/js/simple.functions';
import LP from '../0-lp';


LP.dlgClonePage = {
    orgAfterSubmit: null,
    prepare: function (selector, params) {
        LP.dlgClonePage.orgAfterSubmit = params.afterSubmit;
        $(selector).click(function () {
            if (!$(this).is('[disabled]')) {
                LP.Dialog.open($.extend(params, {
                    name: 'clonePage',
                    ajax: $(this).attr('url'),
                    request: $(this).attr('url_params'),
                    title: this.title,
                    width: 600,
                    height: 400,
                    sizeable: true,
                    onLoad: LP.dlgClonePage.onLoad,
                    afterSubmit: LP.dlgClonePage.onSubmit
                }));
            }
            return false;
        });
    },

    onSubmit: function (json) {
        let afterSubmit = is_function(LP.dlgClonePage.orgAfterSubmit) ? LP.dlgClonePage.orgAfterSubmit : false;
        if (json.ask) {
            LP.UI.confirm(json.ask, function () {
                    $('#lp-current-url').html(json.targetURL);
                    window.location.href = '/#/poll/' + json.pollId + '/create/questionnaire';
                },
                afterSubmit);
        } else {
            afterSubmit && afterSubmit(json);
        }
        return true;

    },

    onLoad: function () {
        $('#otherPoll').on('click', LP.dlgClonePage.toggleOtherPoll);
    },

    toggleOtherPoll: function () {
        if ($(this).is('[disabled]')) return false;
        let showWarning = $(this).data('warning');

        if ($(this).is(':checked')) {
            $('#targetPoll').removeAttr('disabled');

            if (showWarning) {
                $('#diff_poll_info').show();
            }

            $('#moveItem').removeAttr('disabled');
            $('label[for="moveItem"]').removeClass('disabled');
        } else {
            if (showWarning) {
                $('#diff_poll_info').hide();
            }

            $('#targetPoll').attr('disabled', '1');
            $('#moveItem').attr('disabled', '1');
            $('label[for="moveItem"]').addClass('disabled');
            $('#copyItem').attr('checked', '1');
        }
    }

};

LP.dlgClonePageItem = {
    prepare: function (selector, params) {
        $(selector).click(function () {
            if (!$(this).is('[disabled]')) {
                LP.Dialog.open($.extend(params, {
                    name: 'cloneItem',
                    ajax: $(this).attr('url'),
                    request: $(this).attr('url_params'),
                    title: this.title,
                    width: 650,
                    height: 450,
                    sizeable: true,
                    onLoad: LP.dlgClonePageItem.onLoad,
                    afterSubmit: LP.dlgClonePageItem.onSubmit
                }));
            }
            return false;
        });
    },

    onLoad: function () {
        $('#targetPoll').change(LP.dlgClonePageItem.reloadPages).change();
    },

    onSubmit: function (json) {
        if (json.ask) {
            LP.UI.confirm(json.ask, function () {
                    $('#lp-current-url').html(json.targetURL);
                    window.location.href = '/#/poll/' + json.pollId + '/create/questionnaire';
                },
                function () {
                    var jsonX = json;
                    jsonX.pageId = json.sourcePage;
                    jsonX.pollId = json.sourcePoll;
                    LP.questionairePage.reloadPage(jsonX);
                });
        }

        if (json.isMoved) {
            const $sourcePageItem = $('#page_' + json.sourcePage).find('li#pageitem_' + json.pageitemId);
            $sourcePageItem.remove();
        }

        LP.questionairePage.insertPageItem(json);

        return true;
    },

    reloadPages: function () {
        var pollId = $('#targetPoll').val();
        if (!pollId) return;

        var targetPages = $('#targetPages');
        targetPages.html('<option>...</option>');

        window.Browser.send('backend/getPageNames/', 'poll=' + pollId,
            function (json) {
                targetPages.empty();
                targetPages.val('');
                if (json.pages) {
                    $.each(json.pages, function (index, desc) {
                        var option = $('<option></option>');
                        option.val(desc.id).html(desc.text).attr('title', desc.text);
                        targetPages.append(option);
                    });
                }
            }
        );
    }
};